var forms = {
  init : function() {
    $('.anim-ph-label input, .anim-ph-label textarea')
      .off ( 'keydown' )
      .on  ( 'keydown', function ( evt ) {
        if ( $(this).val().length === 0 ) {
          $(this).removeClass('filled');
        }
        else {
          $(this).addClass('filled');
        }
      });
  },
};